/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Create_Account_NameInputs */

const th_admin_create_account_name = /** @type {(inputs: Admin_Create_Account_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ชื่อ-นามสกุล`)
};

const en_admin_create_account_name = /** @type {(inputs: Admin_Create_Account_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full name`)
};

const ja_admin_create_account_name = /** @type {(inputs: Admin_Create_Account_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`氏名`)
};

const zh_admin_create_account_name = /** @type {(inputs: Admin_Create_Account_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`姓名`)
};

const es_admin_create_account_name = /** @type {(inputs: Admin_Create_Account_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre completo`)
};

const pt_admin_create_account_name = /** @type {(inputs: Admin_Create_Account_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome completo`)
};

const id_admin_create_account_name = /** @type {(inputs: Admin_Create_Account_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nama lengkap`)
};

const fr_admin_create_account_name = /** @type {(inputs: Admin_Create_Account_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom complet`)
};

const tl_admin_create_account_name = /** @type {(inputs: Admin_Create_Account_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buong pangalan`)
};

const vi_admin_create_account_name = /** @type {(inputs: Admin_Create_Account_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Họ và tên`)
};

const ko_admin_create_account_name = /** @type {(inputs: Admin_Create_Account_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이름`)
};

const de_admin_create_account_name = /** @type {(inputs: Admin_Create_Account_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vollständiger Name`)
};

const ru_admin_create_account_name = /** @type {(inputs: Admin_Create_Account_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Полное имя`)
};

const tr_admin_create_account_name = /** @type {(inputs: Admin_Create_Account_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ad soyad`)
};

const it_admin_create_account_name = /** @type {(inputs: Admin_Create_Account_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome e cognome`)
};

const pl_admin_create_account_name = /** @type {(inputs: Admin_Create_Account_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imię i nazwisko`)
};

const uk_admin_create_account_name = /** @type {(inputs: Admin_Create_Account_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Повне ім'я`)
};

const hi_admin_create_account_name = /** @type {(inputs: Admin_Create_Account_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पूरा नाम`)
};

const ar_admin_create_account_name = /** @type {(inputs: Admin_Create_Account_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الاسم الكامل`)
};

const ms_admin_create_account_name = /** @type {(inputs: Admin_Create_Account_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nama penuh`)
};

const bn_admin_create_account_name = /** @type {(inputs: Admin_Create_Account_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`পুরো নাম`)
};

const zh_tw2_admin_create_account_name = /** @type {(inputs: Admin_Create_Account_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`姓名`)
};

const zh_hk2_admin_create_account_name = /** @type {(inputs: Admin_Create_Account_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`姓名`)
};

const ur_admin_create_account_name = /** @type {(inputs: Admin_Create_Account_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`پورا نام`)
};

const fa_admin_create_account_name = /** @type {(inputs: Admin_Create_Account_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نام کامل`)
};

const sw_admin_create_account_name = /** @type {(inputs: Admin_Create_Account_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jina kamili`)
};

const nl_admin_create_account_name = /** @type {(inputs: Admin_Create_Account_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volledige naam`)
};

/**
* | output |
* | --- |
* | "Full name" |
*
* @param {Admin_Create_Account_NameInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const admin_create_account_name = /** @type {((inputs?: Admin_Create_Account_NameInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Create_Account_NameInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_admin_create_account_name(inputs)
	if (locale === "ja") return ja_admin_create_account_name(inputs)
	if (locale === "zh") return zh_admin_create_account_name(inputs)
	if (locale === "es") return es_admin_create_account_name(inputs)
	if (locale === "pt") return pt_admin_create_account_name(inputs)
	if (locale === "id") return id_admin_create_account_name(inputs)
	if (locale === "fr") return fr_admin_create_account_name(inputs)
	if (locale === "tl") return tl_admin_create_account_name(inputs)
	if (locale === "vi") return vi_admin_create_account_name(inputs)
	if (locale === "ko") return ko_admin_create_account_name(inputs)
	if (locale === "de") return de_admin_create_account_name(inputs)
	if (locale === "ru") return ru_admin_create_account_name(inputs)
	if (locale === "tr") return tr_admin_create_account_name(inputs)
	if (locale === "it") return it_admin_create_account_name(inputs)
	if (locale === "pl") return pl_admin_create_account_name(inputs)
	if (locale === "uk") return uk_admin_create_account_name(inputs)
	if (locale === "hi") return hi_admin_create_account_name(inputs)
	if (locale === "ar") return ar_admin_create_account_name(inputs)
	if (locale === "ms") return ms_admin_create_account_name(inputs)
	if (locale === "bn") return bn_admin_create_account_name(inputs)
	if (locale === "zh-TW") return zh_tw2_admin_create_account_name(inputs)
	if (locale === "zh-HK") return zh_hk2_admin_create_account_name(inputs)
	if (locale === "ur") return ur_admin_create_account_name(inputs)
	if (locale === "fa") return fa_admin_create_account_name(inputs)
	if (locale === "sw") return sw_admin_create_account_name(inputs)
	if (locale === "nl") return nl_admin_create_account_name(inputs)
	return en_admin_create_account_name(inputs)
});